import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';

import { AllServerUsersSubspaceName } from '~src/app/state/SpaceInfo';

import { ServerUrls } from '../../../ServerUrls';
import { RouterError } from '../../RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../../SpacesSiteUrls';
import { AllServerUsersAndIdentitiesSpaceProvider } from './AllServerUsersAndIdentitiesSpaceProvider';

export interface AllServerUsersAndIdentitiesSpaceRouterProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls;
}

export class AllServerUsersAndIdentitiesSpaceRouter extends React.Component<AllServerUsersAndIdentitiesSpaceRouterProps> {

  constructor(props: AllServerUsersAndIdentitiesSpaceRouterProps) {
    super(props);
  }

  public render() {
    return (
      <Switch>
        {/* The old users root path will still render the list page for easier backwards compatibility with test frameworks or other UI automation
             that may rely on using that path. */}
        <Route exact path={ServerUrls.getInstance().usersPath()} render={this.provider('list')} />
        <Route exact path={ServerUrls.getInstance().allUserIdentitiesPath()} render={this.provider('identities')} />

        <Route render={() => <RouterError errorType={'default'} urls={this.props.urls} />} />
      </Switch>
    );
  }

  private provider = (subspaceName: AllServerUsersSubspaceName): (props: RouteComponentProps) => JSX.Element => {
    return (): JSX.Element => {
      return <AllServerUsersAndIdentitiesSpaceProvider {...this.props}
        subspaceName={subspaceName}
      />;
    };
  }
}
